module.exports = __webpack_public_path__ + "static/media/contactsyros.f30bae74.png";